export const LOGIN_ACTION = "[actions] login user";
export const LOGOUT_ACTION = "[actions] logout user";
export const AUTH_ACTION = "[actions] do user auth";
export const AUTO_LOGIN_ACTION = "[actions] auth auto-login";
export const AUTO_LOGOUT_ACTION = "[actions] auth log-out";
export const SET_USER_TOKEN_DATA_MUTATION = "[mutations] set user token data";
export const LOADING_SPINNER_SHOW_MUTATION = "[mutations] show loading spinner";
export const SET_AUTO_LOGOUT_MUTATION = "[mutations] set autologout";
export const GET_USER_TOKEN_GETTER = "[getters] auth user token";
export const IS_USER_AUTHENTICATED_GETTER = "[getters] is user autenticated";
export const GET_USER_LEVEL_GETTER = "[getters] user level";
export const GET_USER_LEVELNAME_GETTER = "[getters] user level name";
export const GET_USER_NAME_GETTER = "[getters] user name";
export const GET_USER_ID_GETTER = "[getters] user id";
export const GET_USER_EMAIL_GETTER = "[getters] user email";

export const SET_IMAGE_MUTATION = "[mutations] set user image";
export const AUTO_IMAGE_ACTION = "[actions]  image change";
export const IMAGE_ACTION = "[actions] set new image";
export const GET_USER_AVATAR_GETTER = "[getters] user avatar";

export const SET_TEAMACTIONS_MUTATION = "[mutations] set team actions";
export const AUTO_TEAMACTIONS_ACTION = "[actions]  team actions change";
export const TEAMACTIONS_ACTION = "[actions] set new team actions";
export const GET_TEAMACTIONS_GETTER = "[getters] team actions";
export const GET_ACTIONSLEVEL_GETTER = "[getters] actions level";
export const GET_ACTIONSCOMPLETE_GETTER = "[getters] actions complete";

export const SET_EDITION_MUTATION = "[mutations] set edition";
export const AUTO_EDITION_ACTION = "[actions]  edition change";
export const EDITION_ACTION = "[actions] set edition image";
export const GET_EDITION_GETTER = "[getters] edition";

export const SET_IDTOCANCEL_MUTATION = "[mutations] set id to cancel";
export const AUTO_IDTOCANCEL_ACTION = "[actions]  id to cancel change";
export const IDTOCANCEL_ACTION = "[actions] set id to cancel";
export const GET_IDTOCANCEL_GETTER = "[getters] id to cancel";

export const SET_SECTION_MUTATION = "[mutations] set section and description";
export const AUTO_SECTION_ACTION = "[actions]  section and description change";
export const SECTION_ACTION = "[actions] set section and description";
export const GET_SECTION_GETTER = "[getters] section";

export const GET_TEBID_GETTER = "[getters] tebID";
export const GET_TEBNAME_GETTER = "[getters] teb name";

//TR
export const SET_TRDETAILS_MUTATION = "[mutations] set section and description";
export const AUTO_TRDETAILS_ACTION =
  "[actions]  section and description change";
export const TRDETAILS_ACTION = "[actions] set section and description";
export const GET_TRDETAILS_GETTER = "[getters] section";
export const GET_PROJECTTR_GETTER = "[getters] project TR name";
export const GET_CLOSEDTR_GETTER = "[getters] project TR closed";
export const SET_TRID_MUTATION = "[mutations] set trid";
export const AUTO_TRID_ACTION = "[actions]  trid change";
export const TRID_ACTION = "[actions] set new trid";
export const GET_TRID_GETTER = "[getters] trid";
export const AUTO_TROBSERVATIONS_ACTION = "[actions]  tr observations";
export const GET_TROBSERVATIONS_GETTER = "[getters] tr observations";
export const TROBSERVATIONS_ACTION = "[actions] set new observations";
export const SET_TROBSERVATIONS_MUTATION = "[mutations] set observations";

//FRR
export const SET_FRRID_MUTATION = "[mutations] set frrid";
export const AUTO_FRRID_ACTION = "[actions]  frrid change";
export const FRRID_ACTION = "[actions] set new frrid";
export const GET_FRRID_GETTER = "[getters] frrid";
export const GET_PROJECTFRR_GETTER = "[getters] project FRR name";
export const GET_CLOSEDFRR_GETTER = "[getters] project FRR closed";

//Payload
export const SET_PLID_MUTATION = "[mutations] set payloadid";
export const AUTO_PLID_ACTION = "[actions]  payloadid change";
export const PLID_ACTION = "[actions] set new payloadid";
export const GET_PLID_GETTER = "[getters] payloadid";
export const SET_PLOBSERVATIONS_MUTATION = "[mutations] set observations";
export const AUTO_PLOBSERVATIONS_ACTION = "[actions]  team observations";
export const PLOBSERVATIONS_ACTION = "[actions] set new observations";
export const GET_PLOBSERVATIONS_GETTER = "[getters] team observations";
export const GET_PROJECTPL_GETTER = "[getters] project Payload name";
export const GET_CLOSEDPL_GETTER = "[getters] project Payload closed";

//Vehicle Design
export const SET_VDID_MUTATION = "[mutations] set designid";
export const AUTO_VDID_ACTION = "[actions]  designdid change";
export const VDID_ACTION = "[actions] set new designdid";
export const GET_VDID_GETTER = "[getters] designdid";
export const SET_VDOBSERVATIONS_MUTATION = "[mutations] set observations";
export const AUTO_VDOBSERVATIONS_ACTION = "[actions]  team observations";
export const VDOBSERVATIONS_ACTION = "[actions] set new observations";
export const GET_VDOBSERVATIONS_GETTER = "[getters] team observations";
export const GET_PROJECTVD_GETTER = "[getters] project Design name";
export const GET_CLOSEDVD_GETTER = "[getters] project Design closed";

//Flight Peformance
export const SET_FPID_MUTATION = "[mutations] set designid";
export const AUTO_FPID_ACTION = "[actions]  designdid change";
export const FPID_ACTION = "[actions] set new designdid";
export const GET_FPID_GETTER = "[getters] designdid";
export const SET_FPOBSERVATIONS_MUTATION = "[mutations] set observations";
export const AUTO_FPOBSERVATIONS_ACTION = "[actions]  team observations";
export const FPOBSERVATIONS_ACTION = "[actions] set new observations";
export const GET_FPOBSERVATIONS_GETTER = "[getters] team observations";
export const GET_PROJECTFP_GETTER = "[getters] project Design name";
export const GET_CLOSEDFP_GETTER = "[getters] project Design closed";
//export const GET_APOGEE_GETTER = "[getters] apogee getter";

//teste
export const SET_ID_MUTATION = "[mutations] set id";
export const AUTO_ID_ACTION = "[actions]  id change";
export const ID_ACTION = "[actions] set new id";
export const GET_ID_GETTER = "[getters] get id";

export const SET_OBSERVATIONS_MUTATION = "[mutations] set observations";
export const AUTO_OBSERVATIONS_ACTION = "[actions]  team observations";
export const OBSERVATIONS_ACTION = "[actions] set new observations";
export const GET_OBSERVATIONS_GETTER = "[getters] team observations";

export const GET_PROJECT_GETTER = "[getters] project Design name";
export const GET_CLOSED_GETTER = "[getters] project Design closed";
export const GET_APOGEE_GETTER = "[getters] apogee getter";

// Session expiry warning + countdown
export const SET_EXPIRES_AT = "[mutations] set expiresAt";
export const SET_EXPIRY_WARNING = "[mutations] set expiry warning visible";
export const SET_COUNTDOWN = "[mutations] set expiry countdown seconds";
export const RESET_WARNING = "[mutations] reset expiry warning";
